export default "__VITE_ASSET__BbMKfgrk__"